import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { numberWithCommas } from '../../../../utils/consts/index';
import './paymentType.scss';
class PaymentType extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    let {
      user,
      paymentType,
      creditInfo,
      marginClassName = '',
      isReserveAvailable,
      totalPrice,
      commission = 0,
    } = this.props;
    let finalPrice = (parseFloat(totalPrice) + parseFloat(commission)) / 10;
    let stakeholder = JSON.parse(localStorage.getItem('stakeholder'));
    let creditTooltipTitle =
      creditInfo && creditInfo.creditAmount > 0
        ? `(${this.props.intl.formatMessage({
            id: 'profile.menucredit',
          })}  ${numberWithCommas(
            (creditInfo.creditAmount / 10).toFixed(0),
          )}  ${
            creditInfo.creditMoneyUnit.moneyUnit === 'IRR'
              ? this.props.intl.formatMessage({
                  id: 'booking.toman',
                })
              : creditInfo.creditMoneyUnit
              ? creditInfo.creditMoneyUnit.moneyUnit
              : ''
          })`
        : '';
    let walletTooltipTitle =
      creditInfo && creditInfo.walletAmount > 0
        ? `(${numberWithCommas((creditInfo.walletAmount / 10).toFixed(0))}   ${
            creditInfo.walletMoneyUnit.moneyUnit === 'IRR'
              ? this.props.intl.formatMessage({
                  id: 'booking.toman',
                })
              : creditInfo.walletMoneyUnit
              ? creditInfo.walletMoneyUnit.moneyUnit
              : ''
          })`
        : '';
    let isAgency =
      user &&
      stakeholder &&
      user.profiles &&
      user.profiles.some((item) => item.profileId === stakeholder);
    if (user) {
      return (
        <div
          className="d-flex w-100 flex-column text-white p-4 font-small paymentCardGradient"
          style={{ borderRadius: 15 }}
        >
          <div className="d-flex w-100 justify-content-start  align-items-center ">
            <div className="d-flex   ">
              <FormattedMessage id="booking.selectpaymenttype" />
            </div>
            <div className={`d-flex  px-2 `}>
              {`${numberWithCommas(
                parseFloat(finalPrice).toFixed(0),
              )}  ${this.props.intl.formatMessage({
                id: 'booking.toman',
              })}`}
            </div>
          </div>
          <div
            className={`d-flex w-100 justify-content-between py-3 ${marginClassName}`}
          >
            <div
              className={`d-flex align-items-center font-small text-white p-2 w-25 justify-content-center rounded-pill  ${
                paymentType === 'online'
                  ? 'bg-secondary-light text-white '
                  : 'bg-third-light text-secondary '
              }`}
              onClick={() => this.props.handleControl('online')}
            >
              <FormattedMessage id="booking.online" />
            </div>

            <div
              className={`d-flex align-items-center font-small text-white p-2 w-25 justify-content-center rounded-pill  ${
                creditInfo && creditInfo.creditAmount > 0
                  ? paymentType === 'credit'
                    ? 'bg-secondary-light text-white '
                    : 'bg-third-light text-secondary '
                  : 'bg-third text-dark'
              }`}
              onClick={() =>
                creditInfo && creditInfo.creditAmount > 0
                  ? this.props.handleControl('credit')
                  : null
              }
            >
              <FormattedMessage id="booking.fromcredit" />
            </div>

            <div
              className={`d-flex align-items-center font-small text-white p-2 w-25 justify-content-center rounded-pill  ${
                isAgency && isReserveAvailable
                  ? paymentType === 'reserve'
                    ? 'bg-secondary-light text-white '
                    : 'bg-third-light text-secondary '
                  : 'text-dark bg-third'
              }`}
              onClick={() =>
                isAgency && isReserveAvailable
                  ? this.props.handleControl('reserve')
                  : null
              }
            >
              <FormattedMessage id="booking.temporaryreservation" />
            </div>
          </div>
          {((creditInfo && creditInfo.creditAmount > 0) || true) && (
            <div
              className={`d-flex w-100 justify-content-center text-white py-3 ${marginClassName}`}
            >
              <FormattedMessage id="profile.credit" />

              {`${numberWithCommas(
                parseFloat(creditInfo.creditAmount || 0).toFixed(0),
              )}  ${this.props.intl.formatMessage({
                id: 'booking.toman',
              })}`}
            </div>
          )}
        </div>
      );
    } else return <div />;
  }
}

export default injectIntl(PaymentType);
